/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2025 Deere & Company

import './dealer-mapping.scss';
import { FormattedMessage } from 'react-intl';
import PinPlateReport from './pin-plate-report';
import PropTypes from 'prop-types';
import React from 'react';

const PinPlateSearch = (props) => (
    props.pinPlateData.length ? (
        <div>
            <section className="transfer-approvals">
                <PinPlateReport
                    actions={props.actions}
                    auth={props.auth}
                    pinPlates={props.pinPlateData}
                />
            </section>
        </div>
    ) : (
        <span className="help-text">
            <FormattedMessage id="NO_RESULTS_FOUND" defaultMessage="No results found" />
        </span>
    )
);

PinPlateSearch.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object.isRequired,
    pinPlateData: PropTypes.array,
    updateTransferComment: PropTypes.func,
};

export default PinPlateSearch;
